<template>
<div class="box">
  <div class="box-header">
    <div class="input-group pull-right" style="width:auto;margin-top:-2px;" v-if="isSearch">
      <!--div class="input-group-btn dropdown">
        <button type="button" class="btn btn-md line-2 dropdown-toggle" data-toggle="dropdown">이름</button>
        <div class="dropdown-menu dropdown-menu-scale">
          <a class="dropdown-item selected">이름</a>
          <a class="dropdown-item">계통</a>
        </div>
      </div-->
      <input v-model="term" type="text" class="form-control" placeholder="이름을 입력하세요." style="width:150px;">
      <button type="button" class="btn btn-m search" @click="search()">
        <i class="icon-search"></i>
      </button>
    </div>
    <h3>{{title}}&nbsp;</h3>
    <p>{{description}}</p>
  </div>
  <div class="mt-0">
    <div class="thead no-border">
      <table class="tbl">
        <colgroup>
          <col width="200px"/>
          <col width="auto"/>
          <col v-if="isDropdown" width="114px"/>
        </colgroup>
        <thead>
          <tr>
            <th>이름</th>
            <th>계통</th>
            <th v-if="isDropdown">하위 조직 포함</th>
          </tr>
        </thead>
      </table>
    </div>
    <!--div class="box-body scrollable" ui-jp="mCustomScrollbar" ui-options="{theme:'dark-thick'}" style="margin-bottom:20px"-->
    <div class="tbody  box-body scrollable" ui-jp="mCustomScrollbar" ui-options="{theme:'dark-thick', height: '644px'}" :style="[{'max-height': height + 'px'}, {'height': height + 'px'}, {'overflow-y': 'scroll'}]">
      <table class="tbl">
        <colgroup>
          <col width="200px"/>
          <col width="auto"/>
          <col v-if="isDropdown" width="100px"/>
        </colgroup>
        <tbody>
          <tr v-for="(item, index) in items" :key="index" @click="selectItem(item)" :class="[item.checked ? 'checked' : null]">
            <td>{{item.team}}</td>
            <td>{{fullPath(item.fullDeptName)}}</td>
            <td v-if="isDropdown" class="td-compo-box">
              <dropdown v-model="item.isContainChildren" displayName="display" valueName="value" :datasource="containChild" title="" :isSelectionFirstData="true" :width="80" @close="updateRow(item)"/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>

<script>
import dropdown from "@/components/Dropdown.vue"

export default {
  components:{
    dropdown
  },
  props: ['title', 'description', 'isSearch', 'height', 'isDropdown', 'grade', 'datasource'],
  computed: {
    isContain(){
      return (item) =>{
        return item.isContainChildren;
      }
    },
    fullPath(){
      return (item) =>{
        return item.replaceAll(';', ' > ');
      }
    },
    items(){
      var that = this;
      if(this.datasource && this.datasource.filter)
        return this.datasource.filter(x=>x.idcGrade == that.grade);
    },
    isChecked(){
      return (item) =>{
        return item.checked? 'checked' : null 
      }
    } 
  },
  data(){
    return {
      containChild: [
        {display: '포함', value: 1},
        {display: '미포함', value: 0}
      ],
      term: null,
    }
  },
  methods: {
    selectItem(item){
      if(!($(event.target).prop('tagName') == 'TR' || $(event.target).prop('tagName') == 'TD')){
        //event.stopImmediatePropagation();
        //event.stopPropagation();
        return;
      }
      debugger;
      item.checked = !item.checked;
      //this.$forceUpdate();
      this.$emit('selectRow', this.items)
    },
    updateRow(item){
      debugger;
			var that = this;

			var o = {};
      o.idcGrade = item.idcGrade;
      o.isContainChildren = item.isContainChildren;
			this.$http.put('/api/private/department/' + item.teamCode + '?' + $.param(o)).then((result) =>{
        that.$toast.success(that.$t('변경되었습니다.'));
			});
    },
    search(){
      this.$emit('search', this.term)
    }
  }
}
</script>

<style>

</style>
